import { render, staticRenderFns } from "./AppointmentTemplate.vue?vue&type=template&id=90c3d9a6&"
import script from "./AppointmentTemplate.vue?vue&type=script&lang=js&"
export * from "./AppointmentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports